import { ThemeProvider } from "@/components/theme-provider";
import { ThemeToggle } from "@/components/theme-toggle";
import { HelpButton } from "@/components/help-button";
import { TypeChart } from "@/components/TypeChart";
import { HelpPage } from "@/components/HelpPage";
import { useHelpNavigation } from "@/lib/helpNavigation";
import "./index.css";

export function App() {
  const { isOpen, openHelp, closeHelp } = useHelpNavigation();

  return (
    <ThemeProvider defaultTheme="system" storageKey="pokemon-theme">
      <div className="fixed top-4 right-4 z-40 flex gap-2">
        <HelpButton onClick={openHelp} />
        <ThemeToggle />
      </div>
      {isOpen && <HelpPage onClose={closeHelp} />}
      <TypeChart />
    </ThemeProvider>
  );
}

export default App;
